import makeStyles from '@mui/styles/makeStyles';
import { Box, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import React from 'react';
import {
  HotStreakParameter,
  PayRateFormProps,
} from '../../../interfaces/PayRate';
import { generateNumberInput } from '../../../utilities/PayRates';

export const HotStreakParameterForm = (props: PayRateFormProps) => {
  const classes = useStyles();

  const param = props.currentState as HotStreakParameter;

  return (
    <Box component='div' className={classes.formWrapper}>
      <Box className={classes.row}>
        <Box component='div' className={classes.smallNumberField}>
          {generateNumberInput<HotStreakParameter>(
            true,
            false,
            param,
            props.setter,
            'prioritizationThreshold',
            props.isDisabled,
            'Prioritization Threshold',
            0,
            '',
            undefined,
            false,
            false,
            false,
          )}
        </Box>
        <Box component='div' className={classes.largeNumberField}>
          {generateNumberInput<HotStreakParameter>(
            true,
            false,
            param,
            props.setter,
            'timeBasedFairnessThresholdInMinutes',
            props.isDisabled,
            'Time Based Fairness Threshold (Minutes)',
            0,
            '',
            undefined,
            false,
            false,
            false,
          )}
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formWrapper: {
      marginTop: theme.spacing(2),
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'column',
    },
    row: {
      display: 'flex',
      flexGrow: 1,
      flexDirection: 'row',
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5),
    },
    smallNumberField: {
      width: 200,
      marginRight: theme.spacing(2),
    },
    largeNumberField: {
      width: 330,
      marginRight: theme.spacing(2),
    },
  }),
);
